import React, { FC } from 'react';
import { Modal } from '@mui/material';
import { DeleteModal, SuccessModal } from './components';
import { useAppDispatch, useAppSelector } from 'common/hooks/redux';
import { Loader } from 'common/components';
import { selectProfessional } from 'applicaiton/store/reducers/Professionals/ProfessionalsSlice';
import { deleteProfessionals } from 'applicaiton/store/reducers/Professionals/ActionCreators';
import { useLocation, useNavigate } from 'react-router-dom';
import { PathNames } from 'applicaiton/routes';
import {
  getProfilesFromSessionStorage,
  getUserRole,
  Profile,
} from 'applicaiton/sessionStorage/auth';
import { usersRefreshToken } from 'applicaiton/store/reducers/Users/ActionCreators';
import { UserRoles } from 'applicaiton/constants/userRoles';
import { setActiveForm } from 'applicaiton/store/reducers/ClinicOwner/ClinicOwnerSlice';
import { ProfileForm } from 'applicaiton/constants/clincOwnerProfile';

const DeleteProfessionalModal: FC = () => {
  const { isLoading, currentProfessional, deletedSuccess } = useAppSelector(
    (state) => state.professionals,
  );
  const dispatch = useAppDispatch();
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const userRole = getUserRole();
  const isClinicOwnerRole = userRole?.includes(UserRoles.clinicOwner);

  const handleClose = () => {
    dispatch(selectProfessional(null));
    if (isClinicOwnerRole) {
      dispatch(setActiveForm(ProfileForm.previewProfile));
    }
  };

  const handleCloseDeleteModal = () => {
    dispatch(selectProfessional(null));
    if (isClinicOwnerRole) {
      dispatch(setActiveForm(ProfileForm.previewProfile));
    }

    if (pathname.includes('staff/professionals/edit')) {
      navigate(PathNames.professionals);
    }
  };

  const handleSubmit = () => {
    dispatch(deleteProfessionals(Number(currentProfessional?.id))).then(
      (data) => {
        const isCOProfessional =
          data.meta.requestStatus === 'fulfilled' &&
          isClinicOwnerRole &&
          pathname.includes('profile');

        if (isCOProfessional) {
          const profile: Profile[] | null = getProfilesFromSessionStorage();

          if (profile) {
            dispatch(
              usersRefreshToken({
                refreshToken: profile[0].refreshToken,
                email: profile[0].email,
              }),
            );
          }
        }
      },
    );
  };

  const professionalFullName = `${currentProfessional?.firstName || ''} ${
    currentProfessional?.lastName || ''
  }`;

  return (
    <Modal open={!!currentProfessional}>
      <>
        {isLoading && <Loader />}
        {!deletedSuccess && (
          <DeleteModal
            profileName={professionalFullName}
            onClose={handleClose}
            onSubmit={handleSubmit}
          />
        )}

        {deletedSuccess && !isLoading && (
          <SuccessModal
            profileName={professionalFullName}
            onClose={handleCloseDeleteModal}
          />
        )}
      </>
    </Modal>
  );
};

export default DeleteProfessionalModal;
